module.exports = __webpack_public_path__ + "img/partner_supplier_channel3.df59a450.png";